import React from "react"
import {useField} from "formik"
import {TextArea} from ".."

const FormBIOi18nBlock = props => {
    const {label , show , RTL , disabled} = props
    const [field , meta , helpers] = useField(props.name)
    const {name , value} = field
    return (
        <>
        {(value || show) && (<TextArea name={name} disabled={disabled} label={label} RTL={RTL} />)}
        </>
    )
}

export default FormBIOi18nBlock